import { render, staticRenderFns } from "./lazyblock_member_card.vue?vue&type=template&id=6a9cf68f&scoped=true"
import script from "./lazyblock_member_card.vue?vue&type=script&lang=js"
export * from "./lazyblock_member_card.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_member_card.vue?vue&type=style&index=0&id=6a9cf68f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9cf68f",
  null
  
)

export default component.exports